module.exports = "/_next/static/images/f3633a8286f6c6bd40c836ab1bba595a-cuenta-card-xs-full-width.png";